// extracted by mini-css-extract-plugin
export default {"form__input":"forms_form__input__mAyJe","label_field":"forms_label_field__C4093","select_field":"forms_select_field__ETYzC","select_label":"forms_select_label__4u2kT"};